import React from 'react';

type Color = 'white' | 'blue';

type PropsType = {
  color?: Color;
  size?: number;
};

const FacebookIcon = (props: PropsType) => {
  const { color, size } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 52 52">
      <defs>
        <path id="prefix__a" d="M.003.002H52v51.682H.003z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            fill={color === 'white' ? '#FFF' : '#1877F2'}
            d="M52 26C52 11.64 40.36 0 26 0S0 11.64 0 26c0 12.977 9.508 23.734 21.938 25.684V33.516h-6.602V26h6.601v-5.728c0-6.516 3.882-10.116 9.821-10.116 2.845 0 5.82.508 5.82.508v6.399H34.3c-3.23 0-4.237 2.004-4.237 4.06V26h7.21l-1.152 7.516h-6.059v18.168C42.492 49.734 52 38.977 52 26"
            mask="url(#prefix__b)"
          />
        </g>
        <path
          fill={color === 'white' ? '#1877F2' : '#FFF'}
          d="M36.12 33.516L37.274 26h-7.21v-4.877c0-2.056 1.007-4.06 4.237-4.06h3.278v-6.399s-2.975-.508-5.82-.508c-5.939 0-9.82 3.6-9.82 10.116V26h-6.602v7.516h6.601v18.168c1.324.208 2.68.316 4.063.316 1.382 0 2.739-.108 4.063-.316V33.516h6.058"
        />
      </g>
    </svg>
  );
};

FacebookIcon.defaultProps = {
  color: 'white',
  size: 24,
};

export default FacebookIcon;
